import { createSlice } from "@reduxjs/toolkit";
import { nanoid } from "@reduxjs/toolkit"; // For unique IDs

const initialState = {
  notifications: [], // Array of { id, message, type }
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    addNotification: {
      reducer(state, action) {
        state.notifications.push(action.payload);
      },
      prepare(message, type = "info") {
        return {
          payload: {
            id: nanoid(),
            message,
            type,
          }
        };
      },
    },
    removeNotification(state, action) {
      state.notifications = state.notifications.filter(
        (n) => n.id !== action.payload
      );
    },
  },
});

export const { addNotification, removeNotification } = notificationsSlice.actions;

export default notificationsSlice.reducer;
